import { Navigate, Route, Routes } from "react-router-dom";
import { Consult } from "../modules/consult/pages";
import { Login } from "../modules/login/pages/main";
import { PublicRoutes } from "../components/public-routes";
import { ProtectedClientRoutes } from "../components/protected-client-routes";
import { SignUp } from "../modules/login/pages/sign-up";
import { Credits } from "../modules/credits/pages";
import { EmailResetPassword } from "../modules/login/pages/reset-password";
import { SetNewPassword } from "../modules/login/pages/set-new-password";
import { EmailConfirm } from "../modules/login/pages/email-confirm";
import { Configurations } from "../modules/configurations/pages";
import { Accounts } from "../modules/accounts/pages";
import { Scenarios } from "../modules/scenarios/pages";
import ProtectedRoute from "../components/protected-roles-routes";
import { Permissions } from "../modules/users/models";
import { UsersModule } from "../modules/users/pages";
import { NotFound } from "../modules/not-found";
import { History } from "@/modules/history/pages";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { BecomeMember } from "@/modules/embaixador/pages/BecomeMember";
import { Support } from "@/modules/support";
import { SignUpSocial } from "@/modules/login/pages/sign-up-social";
import { Privacy } from "@/modules/login/pages/privacy";
import { ProtectedMasterRoutes } from "@/components/protected-master-routes";
import { MasterDashboard } from "@/modules/dashboard/pages";

import { Home } from "@/modules/home/pages";
import { Ambassador } from "@/modules/ambassador/pages";
 
export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/">
        <Route path="*" element={<NotFound />} />
        <Route index element={<Navigate to={"/login"} />} />
        <Route path="reset-password" element={<SetNewPassword />} />
        <Route
          path="signup"
          element={
            <GoogleReCaptchaProvider
              reCaptchaKey={import.meta.env.VITE_APP_RECAPTCHA_KEY}
            >
              <SignUp />
            </GoogleReCaptchaProvider>
          }
        />
        <Route path="/verify-email" element={<EmailConfirm />} />
        <Route path="/login-social" element={<SignUpSocial />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="login" element={<PublicRoutes />}>
          <Route
            path=""
            element={
              <GoogleReCaptchaProvider
                reCaptchaKey={import.meta.env.VITE_APP_RECAPTCHA_KEY}
              >
                <Login />
              </GoogleReCaptchaProvider>
            }
          />
          {/*tela para inserir o email que será redefinida a senha*/}
          <Route path="request-new-password" element={<EmailResetPassword />} />
        </Route>
        <Route path="reports" element={<ProtectedMasterRoutes />}>
          <Route path="dashboard" element={<MasterDashboard />} />
        </Route>
        <Route path="" element={<ProtectedClientRoutes />}>
          <Route path="home" element={<Home />} />

          <Route path="consult" element={<Consult />} />

          {/* Rotas com permissões específicas */}
          {[
            {
              path: "suporte",
              component: <Support />,
              permission: Permissions.SUPPORT
            },
            {
              path: "configurations",
              component: <Configurations />,
              permission: Permissions.CONFIGURATIONS
            },
            {
              path: "scenarios",
              component: <Scenarios />,
              permission: Permissions.SCENARIOS
            },
            {
              path: "credits",
              component: <Credits />,
              permission: Permissions.CREDITS
            },
            {
              path: "accounts",
              component: <Accounts />,
              permission: Permissions.ACCOUNTS
            },
            {
              path: "users",
              component: <UsersModule />,
              permission: Permissions.USERS
            },
            {
              path: "history",
              component: <History />,
              permission: Permissions.HISTORY
            },
            {
              path: "ambassador",
              //component: <Embaixador />,
              component: <Ambassador />,
              permission: Permissions.AMBASSADOR
            },
            {
              path: "embaixador",
              component: <BecomeMember />,
              permission: Permissions.SEJAMBASSADOR
            }
          ].map(({ path, component, permission }) => (
            <Route
              key={path}
              element={<ProtectedRoute permissions={[permission]} />}
            >
              <Route path={path} element={component} />
            </Route>
          ))}
        </Route>
      </Route>
    </Routes>
  );
};
